import React from 'react';
import { Card, Space, Typography } from 'antd';
import { Main } from '../../container/styled';

const { Title, Paragraph } = Typography;

const PageTitle = ({ title, subtitle, children, extra }) => {
    return (
        <Main>
            <Card
                style={{
                    borderRadius: '18px',
                    border: '1px solid #e6edf7',
                    boxShadow: '0 8px 24px rgba(15, 23, 42, 0.06)',
                    marginBottom: '20px',
                }}
                bodyStyle={{ padding: '24px' }}
                extra={extra}
            >
                <Space direction="vertical" size={8} style={{ width: '100%' }}>
                    <Title level={2} style={{ margin: 0, color: '#102a43' }}>
                        {title}
                    </Title>
                    {subtitle && (
                        <Paragraph style={{ margin: 0, color: '#52606d' }}>
                            {subtitle}
                        </Paragraph>
                    )}
                    {children}
                </Space>
            </Card>
        </Main>
    );
};

export default PageTitle;
